export default (() => ({
  tcVariables: {
    foo: 'bar'
  }
}));